import { ArrayNotEmpty, IsArray, IsOptional, IsString, IsUUID } from 'class-validator';

export class UpdateRegionDto {
  @IsOptional()
  @IsString()
  name?: string;

  @IsOptional()
  @IsArray()
  @ArrayNotEmpty({ message: 'Countries are required' })
  @IsUUID('4', { each: true })
  countryIds?: string[];

  @IsOptional()
  @IsArray()
  @IsUUID('4', { each: true })
  subdivisionIds?: string[];
}
